import React, { useEffect, useRef } from "react";
import { Input } from "reactstrap";
import "./TriStateSwitch.css";

const TriStateSwitch = ({
    checked = false,
    indeterminate = false,
    disabled = false,
    ariaLabel,
    className,
    ...rest
}) => {
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.indeterminate = !!indeterminate;
        }
    }, [indeterminate]);

    return (
        <Input
            type="switch"
            checked={checked}
            disabled={disabled}
            aria-label={ariaLabel}
            aria-checked={indeterminate ? "mixed" : checked}
            innerRef={inputRef}
            className={`tri-state-switch${indeterminate ? " tri-state-switch-mixed" : ""}${className ? ` ${className}` : ""}`}
            {...rest}
        />
    );
};

export default TriStateSwitch;
